export var getVideoTextTrackId = function (kind, lang) { return kind + "-" + lang; };
